import Helper from './Helper';

class Header {
  constructor(config = {}) {
    const {
      headerSelector, //header wrapper (menu open)
      burgerSelector, // burger toggle
      navigationSelector, //php menu
      navItemSelector, // clickable link
      initialActiveItemSelector, // ancestor-active
    } = config;

    this.header = document.querySelector(headerSelector);
    this.burgerToggle = document.querySelector(burgerSelector);
    this.menuCloseToggle = document.querySelectorAll('.js-menu-close');
    this.navigation = document.querySelector(navigationSelector);
    this.navItems = document.querySelectorAll(navItemSelector);
    this.activeItemInit = document.querySelector(initialActiveItemSelector);
    this.closeButton = document.querySelector('.js-menu-close');

    this.initActiveLink();
    this.bindEvents();
  }

  bindEvents() {
    
    this.closeButton?.addEventListener('click', (e) => {
      this.closeMenu();
    })

    this.navItems.forEach(navItem => {
      navItem.addEventListener('click', (event) => this.navItemClick(event, navItem));
    });


    this.burgerToggle?.addEventListener('click', (e) => {
      this.toggleMenu();
    });

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeMenu();
      }
    };
  }

  // open active link
  initActiveLink() {
    this.activeItemInit?.classList.add('active');
  }
  
  // click handler for navItem
  navItemClick = (event, navItem) => {
    if (!event.target.classList.contains('menu__link--level-1')) {
      event.preventDefault();
    }
    this.removeActiveLink();
    navItem.parentNode?.classList.toggle('active');
  }

  toggleMenu() {
    if (this.bIsMenuOpen()) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  bIsMenuOpen() {
    return this.header.classList.contains('menu-open');
  }

  closeMenu() {
    this.header.classList.remove('menu-open');
  }

  openMenu() {
    this.header.classList.add('menu-open');
  }
  
  // remove active link on desktop for only one open item
  removeActiveLink() {
    if (Helper.isDesktop()) {
      this.navItems.forEach(navItem => {
        navItem.parentNode.classList.remove('active');
      });
    }
  }
}

export default Header;